import React from "react";
import { Accordion, Col, Row, Tab, Tabs } from "react-bootstrap";
import Card from "react-bootstrap/Card";
import MediaQuery from "react-responsive";

const getResponsiveTab = (props, isTab, tabClassName, cardClassName) => {
  if (props.shouldHide) {
    return undefined;
  }

  const elementClassName = props.className || "";

  if (isTab) {
    return (
      <Tab
        eventKey={props.eventKey}
        title={props.title}
        className={tabClassName}
        tabClassName={elementClassName}
        mountOnEnter
      >
        {props.wrapped ? (
          <Row>
            <Col>{props.body} </Col>
          </Row>
        ) : (
          props.body
        )}
      </Tab>
    );
  } else {
    return (
      <Card className={`${cardClassName} ${elementClassName}`}>
        <Accordion.Toggle
          as={Card.Header}
          variant="light"
          eventKey={props.eventKey}
        >
          {props.title}
        </Accordion.Toggle>

        <Accordion.Collapse eventKey={props.eventKey} mountOnEnter>
          <Card.Body>{props.body}</Card.Body>
        </Accordion.Collapse>
      </Card>
    );
  }
};

const getResponsiveTabs = (props, isTab) => {
  let tabs = [];

  if (props.tabs) {
    for (let index = 0; index < props.tabs.length; index++) {
      const element = props.tabs[index];

      tabs.push(
        getResponsiveTab(
          element,
          isTab,
          props.tabClassName,
          props.cardClassName
        )
      );
    }
  }
  return tabs;
};

const ResponsiveTabs = props => {
  return (
    <>
      <MediaQuery minWidth={800}>
        <Tabs>{getResponsiveTabs(props, true)}</Tabs>
      </MediaQuery>
      <MediaQuery maxWidth={799}>
        <Row>
          <Col>
            <Accordion
              defaultActiveKey={props.tabs ? props.tabs[0].eventKey : ""}
            >
              {getResponsiveTabs(props, false)}
            </Accordion>
          </Col>
        </Row>
      </MediaQuery>
    </>
  );
};

export default ResponsiveTabs;
